import { Divider, Typography } from "antd";
import React from "react";
import ProductList from "./ProductList";
import "./ProductStyles.css";

const { Title } = Typography;

const ProductManagement = () => {
    const isMobile = window.innerWidth < 768;

    return (
        <div className="product-management-container">
            <Title level={2}>{isMobile ? "Productos" : "Gestión de Productos"}</Title>
            <Divider />

            <ProductList/>
           
        </div>
    );
};

export default ProductManagement; 